/* eslint-disable @typescript-eslint/no-misused-promises */
import FormTextfield, { TextfieldModifier } from 'components/form/textfield';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import {
  useContext, useEffect, useRef, useState,
} from 'react';
import { useTranslation } from 'react-i18next';
import { StoreContext } from '../../../models/import';
import Tooltip, { TooltipAlignEnum, TooltipCursorEnum, TooltipModifier } from '../../tooltip';
import { TextField, MenuItem } from '@mui/material';

export interface ValidationFlowNegativesTableFilterValues {
  currencies: number;
  show_previous_transactions: ShowPreviousTransactions;
  match_same_exchange: boolean;
  amount_accuracy: number;
  time_accuracy: number;
  already_matched: boolean;
}

export enum ShowPreviousTransactions {
  SHOW_PREVIOUS_TRANSACTIONS = 0,
  SHOW_FOLLOWING_TRANSACTIONS = 1,
  SHOW_ALL_TRANSACTIONS = 2,
}

export interface ValidationFlowNegativesTableFiltersProps { // implements TableFilterProps
  filters: ValidationFlowNegativesTableFilterValues;
  onFitlerCB: (e: ValidationFlowNegativesTableFilterValues) => void;

  disabled: boolean;
  tooltipAlignment: TooltipAlignEnum;
  isHidden: boolean;
}

export default function ValidationFlowNegativesTableFilters(props: ValidationFlowNegativesTableFiltersProps) {
  const {
    filters,
    onFitlerCB,
    disabled,
    tooltipAlignment,
    isHidden,
  } = props;
  const { t } = useTranslation();

  const [isFirstLoad, setIsFirstLoad] = useState<boolean>(true);
  const prevFilterRef = useRef<string | null>(null);
  const { userSettings } = useContext(StoreContext);

  const formMethods = useForm({
    mode: 'onChange',
    defaultValues: filters,
  });

   const showPreviousTransactionsItems = [
    { value: ShowPreviousTransactions.SHOW_PREVIOUS_TRANSACTIONS,
      text: t('Show previous transactions', { ns: 'validation' }),
    }, {
      value: ShowPreviousTransactions.SHOW_FOLLOWING_TRANSACTIONS,
      text: t('Show following transactions', { ns: 'validation' }),
    }, {
      value: ShowPreviousTransactions.SHOW_ALL_TRANSACTIONS,
      text: t('Show all transactions', { ns: 'validation' }),
    }];

  useEffect(() => {
    const subscription = formMethods.watch((data) => {
      const jsonString = JSON.stringify(data);
      if (prevFilterRef.current && prevFilterRef.current === jsonString) return;

      prevFilterRef.current = jsonString;
      onFitlerCB(data);
    });

    if (isFirstLoad) {
      setIsFirstLoad(false);
      formMethods.setValue('show_previous_transactions', filters.show_previous_transactions, { shouldValidate: true });
    }

    return () => {
      subscription.unsubscribe();
    };
  }, [formMethods.watch]);

  return (
    <FormProvider {...formMethods}>
      {!isHidden && (
      <form className={`ct_form ${disabled ? '_inactive' : '_active'}`} onSubmit={(e) => e.preventDefault()}>

        <div className="ct_tableFilter" style={{ position: 'relative', top: '5px' }}>
          <>
              <Controller
                control={formMethods.control}
                name="show_previous_transactions"
                render={({ field: { name, value, onChange }, formState }) => (
                  <TextField
                    name={name}
                    id="outlined-select"
                    variant="standard"
                    select
                    defaultValue={value}
                    value={value}
                    placeholder={t('Show previous transactions', { ns: 'validation' })}
                    sx={{ width: '100%' }}
                    size='small'
                    onChange={onChange}
                  >
                    {showPreviousTransactionsItems.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.text}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />

 
          </>


        </div>
      </form>
      )}
    </FormProvider>
  );
}
